import React, { useState, useEffect } from "react";
// 1. IMPORTANT: Change Link to NavLink for active styling
import { Link, NavLink } from "react-router-dom";
import "../csscontainer/Button.css";
import "../csscontainer/Navbar.css";
import sensileLogo from "../assets/images/sensile_logo_1.png"; // Adjust the path as necessary

function Navbar() {
  const [click, setClick] = useState(false);
  const [, setButton] = useState(true);
  const [isHover, setIsHover] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const handleClick = () => setClick(!click);
  const closeMenu = () => setClick(false);

  const showButton = () => {
    if (window.innerWidth <= 960) {
      setButton(false);
    } else {
      setButton(true);
    }
  };

  useEffect(() => {
    showButton();
  }, []);

  window.addEventListener("resize", showButton);

  // Helper function to apply the active class conditionally
  const getNavLinkClass = ({ isActive }) => {
    return isActive ? "nav-links active" : "nav-links";
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <img src={sensileLogo} alt="Sensile Tech " className="navbar-icon" />
        </Link>

        <div className="menu-icon" onClick={handleClick}>
          <i className={click ? "fas fa-times" : "fas fa-bars"} />
        </div>

        <ul className={click ? "nav-menu active" : "nav-menu"}>
          <li className="nav-item" onClick={closeMenu}>
            {/* NavLink for Home. The 'end' prop ensures it only matches '/' exactly */}
            <NavLink to="/" className={getNavLinkClass} end>
              Home
            </NavLink>
          </li>
          <li
            className="nav-item dropdown"
            onMouseEnter={() => {
              if (window.innerWidth > 960) setIsHover(true);
            }}
            onMouseLeave={() => {
              if (window.innerWidth > 960) setIsHover(false);
            }}
            onClick={() => {
              if (window.innerWidth <= 960) setIsOpen((p) => !p);
            }}
          >
            <span className="nav-links no-click">Services</span>

            {(isHover || isOpen) && (
              <ul className="dropdown-menu">
                <li>
                  <NavLink
                    to="/services/fieldDispatch"
                    className="dropdown-link"
                    onClick={() => {
                      setIsOpen(false);
                      setIsHover(false);
                      closeMenu();
                    }}
                  >
                    Fields and Dispatch
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/services/projManagement"
                    className="dropdown-link"
                    onClick={closeMenu}
                  >
                    Project Management
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/services/itServices"
                    className="dropdown-link"
                    onClick={closeMenu}
                  >
                    IT Management and Services
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/services/globalLogistics"
                    className="dropdown-link"
                    onClick={closeMenu}
                  >
                    Global Logistics
                  </NavLink>
                </li>
              </ul>
            )}
          </li>

          <li className="nav-item" onClick={closeMenu}>
            <NavLink to="/AboutUs" className={getNavLinkClass}>
              About Us
            </NavLink>
          </li>
          <li className="nav-item" onClick={closeMenu}>
            <NavLink to="/contactus" className={getNavLinkClass}>
              Contact Us
            </NavLink>
          </li>
          {/* If you had a sign-up button, it would go here... */}
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;